
export const Footer = () => {
  return (
    <div className="footer-div">
      <span className="footer-text">Developed with <span className="red-heart">&#x2764;</span> by Harshitha</span>
    </div>
  )
};
